export const FinImapct = {
  SummaryTabTableLabels: [
    "Total SKUs",
    "Keep",
    "Consult",
    "Delist",
    "SKUs Delisted (%)",
    "Total Volume Delisted (%)",
    "Total Revenue Delisted (%)",
    "MACO Delisted (%)",
    "SCL Delisted (%)",
  ],
};

export const TreeData =[
  {
    label: "MACO Driven",
    selectable: false, // Parent node not selectable
    expanded: true, // Control expand/collapse state
    children: [
      { label: "MACO Improvement: VILC", data: "MACO Improvement: VILC", selectable: true },
      { label: "MACO Improvement: PINC", data: "MACO Improvement: PINC", selectable: true },
      { label: "Negative MACO Uplift", data: "Negative MACO Uplift", selectable: true },
    ],
  },
  {
    label: "Innovations / Marketing",
    selectable: false, // Parent node not selectable
    expanded: true, // Control expand/collapse state
    children: [
      { label: "Long Term Bet", data: "Long Term Bet", selectable: true },
      { label: "Seed <1 year age", data: "Seed <1 year age", selectable: true },
      { label: "Contractual Restriction", data: "Contractual Restriction", selectable: true },
      { label: "Unique SKU", data: "Unique SKU", selectable: true },
    ],
  },
  {
    label: "Volume Improvement",
    selectable: false, // Parent node not selectable
    expanded: true, // Control expand/collapse state
    children: [
      {
        label: "Service Level Impacted/ Unavailability",
        data: "Service Level Impacted/ Unavailability",
        selectable: true,
      },
      { label: "Distribution Expansion", data: "Distribution Expansion", selectable: true },
      {
        label: "Price Tier/Segment re-position",
        data: "Price Tier/Segment re-position",
        selectable: true,
      },
      {
        label: "Transition to MTO(Improve SCL)",
        data: "Transition to MTO(Improve SCL)",
        selectable: true,
      },
    ],
  },
  {
    label: "Others",
    selectable: true, // 'Others' node is selectable
  },
];